export default __webpack_public_path__ + "static/supersupplier-logo-light-b2e8d7e7f0da7b9bc5fe8a61b9a4f412.png";